import path from 'node:path';
import { randomUUID } from 'node:crypto';
import camelCase from 'lodash/camelCase.js';
import { componentGenerator } from '@wix/gena';
import { getDashboardPageExtensionPath } from '@wix/cli-astro-definitions';
import { modifyExtensionsEntry } from '@wix/cli-project-extender';
import { getExtensionRelativePaths } from '../utils/extension-relative-paths.js';

// NOTE: path is relative to the build folder
const DASHBOARD_PAGE_TEMPLATE = path.resolve(
  __dirname,
  '../templates/astro/dashboard-page'
);

export async function generateDashboardPage(
  projectFolder: string,
  route: string,
  title: string
) {
  const cwd = getDashboardPageExtensionPath(projectFolder, route);
  const { relativePathToCodeFile, relativePathToConfigFile } =
    getExtensionRelativePaths({
      cwd,
      projectFolder,
      extensionFileName: route,
      codeFileType: 'tsx',
    });

  const config = {
    id: randomUUID(),
    title,
    component: relativePathToCodeFile,
  };

  await modifyExtensionsEntry(
    projectFolder,
    camelCase(route),
    relativePathToConfigFile
  );

  return await componentGenerator({
    template: DASHBOARD_PAGE_TEMPLATE,
    projectFolder,
    cwd,
    data: {
      route,
      config,
    },
  });
}
